import { render, staticRenderFns } from "./suContractListAction.vue?vue&type=template&id=ed37aa5e&scoped=true"
import script from "./suContractListAction.vue?vue&type=script&lang=js"
export * from "./suContractListAction.vue?vue&type=script&lang=js"
import style0 from "./suContractListAction.vue?vue&type=style&index=0&id=ed37aa5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed37aa5e",
  null
  
)

export default component.exports